import React, { useContext, useEffect, useState } from "react";

import { Card, Col, Form, Image, Row, Spinner, Table } from "react-bootstrap";
import { FaMemory } from "react-icons/fa";
import { IoColorPalette } from "react-icons/io5";
import { MdMonitorHeart } from "react-icons/md";
import AppContext from "../../context/AppContext";
import { scrollToTop } from "../../helper/HelperFunctions";
import MasterLayout from "../../layout/MasterLayout";
import axios from "axios";
import ProductCard from "../../components/cards/ProductCard";
import { withSwal } from "react-sweetalert2";

const Cart = ({ swal }) => {
  const { baseUrl, navigate, isDesktopOrLaptop } = useContext(AppContext);

  const [viewCartLoading, setViewCartLoading] = useState(false);

  const [cart, setCarts] = useState([]);
  const [carts_total, setCartsTotal] = useState(0);
  const [fullname, setFullname] = useState("imran");
  const [customerEmail, setCustomerEmail] = useState("imran@gmail.com");
  const [customerPhone, setCustomerPhone] = useState("923136476240");
  const [streetAddress, setStreetAddress] = useState("testing address");
  const [zipcode, setZipcode] = useState("52250");
  const [city, setCity] = useState("Gujranwala");

  const viewCart = () => {
    setViewCartLoading(true);
    const formData = new FormData();
    let userId = localStorage.getItem("device_id");

    formData.append("user_id", userId);

    axios
      .post(`${baseUrl}/api/guest/viewCart`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((resp) => {
        console.log(resp.data);
        setCarts(resp.data.carts);
        setCartsTotal(resp.data.total_price);
        setViewCartLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setViewCartLoading(false);
      });
  };

  const createCheckoutSession = () => {
    // setViewCartLoading(true);
    const formData = new FormData();
    let userId = localStorage.getItem("device_id");

    formData.append("user_id", userId);
    formData.append("fullname", fullname);
    formData.append("email", customerEmail);
    formData.append("zipcode", zipcode);
    formData.append("city", city);
    formData.append("purchased", 0);
    formData.append("address", streetAddress);
    formData.append("phone", customerPhone);

    axios
      .post(`${baseUrl}/api/guest/createCheckoutSession`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((resp) => {
        console.log(resp.data);
        window.location.href = resp.data.session.url;
      })
      .catch((error) => {
        console.log(error);
        setViewCartLoading(false);
      });
  };

  useEffect(() => {
    scrollToTop();
    viewCart();
  }, []);

  return (
    <MasterLayout>
      <Card className="container rounded-4 p-5">
        <h1 className="text-center txt-green poppins-bold mb-5">My Cart</h1>
        <Row>
          <Col lg={6} md={6} xs={12}>
            <Row>
              {viewCartLoading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    // height: "50vh",
                  }}
                >
                  <Spinner size="lg" />
                </div>
              ) : cart.length > 0 ? (
                cart.map((item, index) => (
                  <>
                    <Col
                      sm={4}
                      xs={6}
                      md={6}
                      lg={6}
                      className="m-0 p-0 d-flex justify-content-center"
                      key={index}
                    >
                      <ProductCard item={item.product} />
                    </Col>
                  </>
                ))
              ) : (
                <h1 className="poppins-semiBold txt-skyBlue text-center my-5">
                  No Items In Cart
                </h1>
              )}
            </Row>
          </Col>

          <Col lg={6} md={6} xs={12} className="p-5">
            <h3 className="poppins-semiBold txt-skyBlue">
              Welcome to checkout
            </h3>
            <hr style={{ borderWidth: 5 }} />
            <Form.Group className="mb-3" controlId="formBasicPassword">
              <Form.Label>Your Full Name</Form.Label>
              <Form.Control
                value={fullname}
                onChange={(event) => {
                  setFullname(event.target.value);
                }}
                required={true}
                type="text"
                placeholder="Fullname"
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicPassword">
              <Form.Label>Your Email</Form.Label>
              <Form.Control
                value={customerEmail}
                onChange={(event) => {
                  setCustomerEmail(event.target.value);
                }}
                required={true}
                type="email"
                placeholder="Email to receive updates about order"
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicPassword">
              <Form.Label>Your Mobile Number</Form.Label>
              <Form.Control
                value={customerPhone}
                onChange={(event) => {
                  setCustomerPhone(event.target.value);
                }}
                required={true}
                type="text"
                placeholder="Mobile Number"
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicPassword">
              <Form.Label>Your Street Address</Form.Label>
              <Form.Control
                value={streetAddress}
                onChange={(event) => {
                  setStreetAddress(event.target.value);
                }}
                required={true}
                type="text"
                placeholder="Street Address"
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicPassword">
              <Form.Label>Your Zipcode</Form.Label>
              <Form.Control
                value={zipcode}
                onChange={(event) => {
                  setZipcode(event.target.value);
                }}
                required={true}
                type="text"
                placeholder="Zipcode"
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicPassword">
              <Form.Label>Your City</Form.Label>
              <Form.Control
                value={city}
                onChange={(event) => {
                  setCity(event.target.value);
                }}
                required={true}
                type="text"
                placeholder="City name"
              />
            </Form.Group>

            <Table className="">
              <tr>
                <th>Total amount</th>
                <td>{carts_total}</td>
              </tr>
              <tr>
                <th>Discount</th>
                <td>N/A</td>
              </tr>
              <tr>
                <th>Sub Total</th>
                <td>{carts_total}</td>
              </tr>
            </Table>
            <Card
              onClick={() => {
                if (fullname == "") {
                  swal.fire({
                    title: "Oops!",
                    text: `Fullname required.`,
                    icon: "error",
                  });
                } else if (customerEmail == "") {
                  swal.fire({
                    title: "Oops!",
                    text: `Email required to send update about your order.`,
                    icon: "error",
                  });
                } else if (customerPhone == "") {
                  swal.fire({
                    title: "Oops!",
                    text: `Phone number required.`,
                    icon: "error",
                  });
                } else if (streetAddress == "") {
                  swal.fire({
                    title: "Oops!",
                    text: `Street address required as delivery address.`,
                    icon: "error",
                  });
                } else if (zipcode == "") {
                  swal.fire({
                    title: "Oops!",
                    text: `Zipcode required.`,
                    icon: "error",
                  });
                } else if (city == "") {
                  swal.fire({
                    title: "Oops!",
                    text: `City required.`,
                    icon: "error",
                  });
                } else {
                  createCheckoutSession();
                }
              }}
              className="mt-5 gradient-bg3 shadow-lg d-flex flex-column justify-content-center align-items-center"
              style={{ borderWidth: 0, height: 60, cursor: "pointer" }}
            >
              <h6 className="poppins-semiBold text-white">Pay Now</h6>
            </Card>
          </Col>
        </Row>
      </Card>
    </MasterLayout>
  );
};

export default withSwal(Cart);
